import { render, staticRenderFns } from "./HelpPage.vue?vue&type=template&id=634979d4&"
import script from "./HelpPage.vue?vue&type=script&lang=ts&"
export * from "./HelpPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports